import { Open_Sans } from 'next/font/google';

const openSansFont = Open_Sans({
  weight: ['400', '700'],
  style: ['normal'],
  subsets: ['latin'],
});

export { openSansFont };
